export const shadows = "-1px 2px 6px rgba(57,72,78,0.16)";
export const font = "Open Sans";
export const height = 48;
export const radius = 8;
